import { render, staticRenderFns } from "./BatchSerialModal.vue?vue&type=template&id=e22e3016&scoped=true&"
import script from "./BatchSerialModal.vue?vue&type=script&lang=js&"
export * from "./BatchSerialModal.vue?vue&type=script&lang=js&"
import style0 from "./BatchSerialModal.vue?vue&type=style&index=0&id=e22e3016&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22e3016",
  null
  
)

export default component.exports